<template>
  <div>
    <vx-card class="mb-4">

          <div class="flex flex-col gap-4">
            <div class="flex flex-col gap-2">
              <validation-observer ref="validatorForm" #default="{valid}">
                <b-form @submit.prevent="createOrUpdate">

                  <validation-provider
                    #default="{ errors }"
                    :name="$t('group_news.name')"
                    rules="required"
                    class="flex-grow"
                    slim>
                    <b-form-group
                      id="input-group-1"
                      :label="$t('group_news.name')"
                      label-for="group_new_name">
                      <b-form-input
                        id="group_news_name"
                        v-model="model.name"
                        :state="errors.length > 0 ? false:null"
                        name="group_news_name"
                        class="required"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                  <!-- -->
                  <b-form-group
                    id="input-group-1"
                    :label="$t('group_news.description')"
                    label-for="group_news_description">
                      <b-form-textarea
                        id="group_news_description"
                        v-model="model.description"
                        rows="4"/>
                  </b-form-group>
                </b-form>
              </validation-observer>

            </div>
            <div class="w-full flex gap-2 justify-end">
              <b-button
                v-if="!isEdit()"
                variant="primary"
                :disabled="!validateForm"
                v-permission="'group_news.create'"
                @click="createOrUpdate">
                {{ $t('action.save') }}
              </b-button>
              <b-button
                v-if="isEdit()"
                variant="primary"
                :disabled="!validateForm"
                v-permission="'group_news.edit'"
                @click="createOrUpdate">
                {{ $t('action.save') }}
              </b-button>

              <b-button
                variant="outline-secondary"
                class="float-right"
                @click="goBack">
                <feather-icon
                  icon="CornerUpLeftIcon"
                  class="mr-50"/>
                <span class="align-middle">{{$t('back')}}</span>
              </b-button>
            </div>
          </div>
    </vx-card>
  </div>
</template>

<script>

import standard from '@/services/standard'
import { isAdmin } from '@/util/Util'
import {
  BForm, BButton, BFormGroup, BInputGroup, BFormTextarea, BCardText, BFormInput
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, min, max} from '@validations'

import GroupNewsService from '@/services/api/GroupNewsService'

export default {

  directives: {

  },
  components: {
    BForm,
    BButton,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    BCardText,
    BFormInput,
    // validations
    ValidationProvider,
    ValidationObserver
  },
  props: {
    id: {
      default: null,
      type: Number
    }
  },

  data: () => ({
    service: null,
    model: {
      id: null,
      name : '',
      description: ''
    }
  }),
  computed: {
    validateForm() {
      return !this.isEmpty(this.model.name)
    },
  },
  beforeMount() {
    this.service = GroupNewsService.build(this.$vs)
  },
  mounted() {
    if (this.id) {
      this.loadData(this.id)
    }
  },

  methods: {
    requiredClass(whichData) {
      return !this.isEmpty(whichData) ? 'w-full' : 'w-full required'
    },
    loadData(id) {
      this.$vs.loading()

      this.service.read(id).then(
        response => {
          this.model = response
        },
        error => {
          this.$vs.loading.close()
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    },
    createOrUpdate() {
      this.$vs.loading()

      const modelData = {
        id: this.id,
        name: this.model.name,
        description: this.model.description,
      }

      this.service.createOrUpdate(modelData).then(
        data => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          this.$router.push(`/group-news/${data.id}/edit`)
        },
        error => {
          //this.showErrors(this.$refs.validatorForm, error)
          //this.notifyError(this.$vs, error, 6000);
        }
      ).finally(() => { this.$vs.loading.close() })
    },
    goBack() {
      this.$router.push('/group-news')
    },
    isAdmin() {
      return isAdmin()
    },
    isEdit() {
      return !_.isNil(this.id)
    },
  }
}
</script>

<style>

</style>
